import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

declare var $:any;

declare var gtag;


@Component({
  selector: 'empresas-header-component',
  templateUrl: './empresas-header.component.html',
  styleUrls: ['./empresas-header.component.scss']
})
export class EmpresasHeaderComponent implements OnInit {
  
  @Input('HeaderHtml')HeaderHtml;
  @Input('menuHeaderHtml') menuHeaderHtml;
  @Input('BotonesDeSlides')BotonesDeSlides;
  @Input('menuFooterHtml')menuFooterHtml;
    @Input('idEvent') idEvent;

  @Output() uuid: EventEmitter<any> = new EventEmitter();
  @Output() buscar: EventEmitter<any> = new EventEmitter();
   @Output() padre: EventEmitter<any> = new EventEmitter();
  

  collapse = false;

  constructor() { 

    
    
  }

  ngOnInit() {

    $('#info-dav').flickity({
      prevNextButtons: true,
      contain: true,
      freeScroll: true,
      pageDots: false
    });

    // console.log("menu - empresas--->"+this.menuHeaderHtml);

  // console.log("localStorage - header personas---->"+localStorage.getItem("idiomaEspañol"));
    //seleccion de idioma
    if (localStorage.getItem("idiomaEspañol") == "true"){ //español
      $("#toggle-button-checkbox").prop('checked', true);
      this.idEvent="true";
    }else{
      $("#toggle-button-checkbox").prop('checked', false); //ingles
      this.idEvent="false";
    }
    $(".layer").click(function (event) {
      $("#lg_slide").fadeIn(500, function () {
      });
    });
  }

  manageMenu(){
    if($("#ul-menu").hasClass("show")){

      $("#ul-menu").removeClass("show");
      $("#ul-menu").addClass("hidden");

      $("#nav-menu").removeClass("content-expand");
      $("#nav-menu").addClass("content-close");

      $("#txt-menu").addClass("menu-inactivo");
      $("#txt-menu").removeClass("menu-activo");

      $("#arrow-down").addClass("d-initial");
      $("#arrow-down").removeClass("hidden");
      $("#arrow-up").removeClass("d-initial");
      $("#arrow-up").addClass("hidden");

      this.collapse = false;
    }else{

      $("#ul-menu").removeClass("hidden");
      $("#ul-menu").addClass("show");

      $("#nav-menu").removeClass("content-close");
      $("#nav-menu").addClass("content-expand");

      $("#txt-menu").addClass("menu-activo");
      $("#txt-menu").removeClass("menu-inactivo");

      $("#arrow-down").removeClass("d-initial");
      $("#arrow-down").addClass("hidden");
      $("#arrow-up").addClass("d-initial");
      $("#arrow-up").removeClass("hidden");

      this.collapse = true;
    }
  }

  redireccionarAPaginaExistente(uuid){
    this.uuid.emit(uuid);
    
    gtag('config', 'UA-174017197-1',{
      'page' : '/empresas/'+uuid, 
      'page-path':'/empresas/'+uuid,
      'page_title' : '/empresas/'+uuid,
      'page_location' : '/empresas/'+uuid
    });
    
    
    $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    $("#lg_slide").removeClass("active");

    $("#ul-menu").removeClass("show");
    $("#ul-menu").addClass("hidden");

    $("#nav-menu").removeClass("content-expand");
    $("#nav-menu").addClass("content-close");

    $("#txt-menu").addClass("menu-inactivo");
    $("#txt-menu").removeClass("menu-activo");

    $("#arrow-down").addClass("d-initial");
    $("#arrow-down").removeClass("hidden");
    $("#arrow-up").removeClass("d-initial");
    $("#arrow-up").addClass("hidden");
  }

  search(){
   this.buscar.emit(true);
   $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    // $("#lg_slide").removeClass("active");
    // $(".c-body").removeClass("overflow-hidden");
   
  }


  changedSlide(evento){
      console.log("evento idiomaEspañol-->"+evento);
      localStorage.setItem("idiomaEspañol",evento.toString());
      this.idEvent=evento.toString();
  }


changedSlide2(){
    if(localStorage.getItem("idiomaEspañol")=="false"){
        localStorage.setItem("idiomaEspañol","true");
        this.idEvent="true";
    }else{
        localStorage.setItem("idiomaEspañol","false");
        this.idEvent="false";
    }

    

  }
  
  functionsjs2() {
    setTimeout(function () {
                    if ($.fn.fullpage.destroy) {
                      $.fn.fullpage.destroy('all');
                      // console.warn("$.fn.fullpage.destroy");
                    }
    
                    setTimeout(function () {
                      $('#fullpage').fullpage({
                        // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                        menu: '#myMenu',
                        scrollingSpeed: 1000,
                        autoScrolling: true,
                        scrollOverflow: false,
                        resize: false,
                        
                        keyboardScrolling: false,
                        afterRender: function () {
                          var $map = document.getElementById('inner-map');
                          var $items = $('#myMenu li');
                          var $next = $('#fp-id-1');
    
                          $items.removeClass('custom-class-active');
                          $next.addClass('example custom-class-active');
                        },
                        onLeave: function(index, nextIndex, direction) {
                          var $items = $('#myMenu li');
                          var $next = $('#fp-id-'+nextIndex);
    
                          $items.removeClass('custom-class-active');
                          $next.addClass('custom-class-active');
                        }
                      });
                    }, 100);
                  }, 75);
    
    }




}
